/**
 * Created by jmulder on 21/03/21
 */


export class Court {

  constructor(
    public court: number,
    public fieldId: string,
    public useSunset: boolean,
    public name: string
  ) {

  }

}
